<fieldset class="rounded-sm border divide-y divide-grey-500">
  <label>
    <input
      type="radio"
      class="radio"
      name="visibility"
      value="AllVisible"
      [(ngModel)]="visibilityChoice"
      (ngModelChange)="selectAll()"
      [attr.data-testid]="'visibility-options-list-AllVisible'"
    />
    <div>
      <h4>Sichtbar für alle</h4>
      <small>Alle Angestellten der InterFace AG können Deine Skills sehen. Dies hilft sich gegenseitig zu unterstützen.</small>
    </div>
  </label>
  <label>
    <input
      type="radio"
      class="radio"
      name="visibility"
      value="NoneVisible"
      [(ngModel)]="visibilityChoice"
      (ngModelChange)="clearSelection()"
      [attr.data-testid]="'visibility-options-list-NoneVisible'"
    />
    <div>
      <h4>Sichtbar für niemanden</h4>
      <small>Nur Du kannst Deine Skills sehen.</small>
    </div>
  </label>
  <label>
    <input
      type="radio"
      class="radio"
      name="visibility"
      value="SpecificGroups"
      [(ngModel)]="visibilityChoice"
      [attr.data-testid]="'visibility-options-list-SpecificGroups'"
    />
    <div>
      <h4>Sichtbar für bestimmte Gruppen</h4>
      <small>Wähle bestimmte Business Units aus, die Deine Skills sehen können.</small>
    </div>
  </label>
  @if (visibilityChoice() === 'SpecificGroups') {
    <if-multi-select-status-group [isOpen]="true" (selectChange)="selectedVisibilityGroups.set($event)" [showSelectAll]="false" />
  }
</fieldset>
